<template lang="pug">
div(id="app")
    custom-header
    keep-alive
        router-view.main(:key="$route.fullPath")
    custom-footer
</template>

<script>
import CustomHeader from '@/components/CustomHeader'
import CustomFooter from '@/components/CustomFooter'
export default {
    name: 'App',
    components: { CustomHeader, CustomFooter },
    created: () => {
        document.title = "Scop3PTM";
    }
}
</script>

<style lang="scss">
html,
body {
    height: 100%;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
#app {
    display: flex;
    flex-direction: column;
    min-height: 100%;
}
.main {
    flex: 1 0 auto;
}
</style>
